import repository from "./repository";
import axios from 'axios';

const host = process.env.VUE_APP_HOST_URL;

let ApiRepository = repository('/api');

ApiRepository.getAllAvailableProjects = () => {
    return axios.get(host + '/api/api_log/all_projects');
};

ApiRepository.getAllData = () => {
    return axios.get(host + '/api/api_log/all_data');
};


export default ApiRepository;